<template>
  <v-card outlined loading="isLoadingEvents">
    <v-stepper v-model="pageIndex">
      <v-stepper-header>
        <template v-for="tab in tabs">
          <v-stepper-step
            :key="`${tab.index}-step`"
            :complete="pageIndex > tab.index"
            :step="tab.index"
            :color="evento.idIntervento > 0 ? 'success' : 'primary'"
          >
            {{ tab.text }}
          </v-stepper-step>

          <v-divider v-if="tab !== tabs" :key="tab.id"></v-divider>
        </template>
        <!-- <v-stepper-step
        v-for="tab in tabs"
          :complete="pageIndex > 1"
          step="1"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Data e ora
        </v-stepper-step> -->
        <!-- 
        <v-divider></v-divider>
        <v-stepper-step
          :complete="pageIndex > 2"
          step="2"
          
      
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Operatori
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          :complete="pageIndex > 3"
          step="3"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Dati Intervento
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          :complete="pageIndex > 4"
          step="4"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Cliente
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="pageIndex > 5"
          step="5"
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Attrezzature
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="pageIndex > 6"
          step="6"
          
          v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        >
          Mezzi
        </v-stepper-step> -->
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="GetRealPageIndexFromPageId(1)">
          <div class="mb-12">
            <StepDataOra
              ref="StepDataOra"
              v-bind:eventInfo="evento"
            ></StepDataOra>
          </div>
        </v-stepper-content>
        <v-stepper-content :step="GetRealPageIndexFromPageId(2)">
          <div class="mb-12">
            <FrmSelectResources
              ref="StepSelectOperators"
              v-bind:events="events" 
              minItemSelected="1"
              resources-type="Uomo"
              v-bind:eventInfo="evento"
            ></FrmSelectResources>
          </div>
        </v-stepper-content>
        <v-stepper-content :step="GetRealPageIndexFromPageId(3)">
          <div class="mb-12">
            <StepEventInfo
              ref="StepEventInfo"
              v-bind:events="events"
              v-bind:updateComponents="updateComponents"
            v-on:commessaSelected="commessa_selected"
              v-bind:eventInfo="evento"
            ></StepEventInfo>
          </div>
        </v-stepper-content>
        <v-stepper-content :step="GetRealPageIndexFromPageId(4)">
          <div class="mb-12">
            <StepCustomerHeadquarter
              v-bind:updateComponents="updateComponents"
              ref="StepCustomerHeadquarter"
              v-bind:eventInfo="evento"
            ></StepCustomerHeadquarter>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="GetRealPageIndexFromPageId(5)">
          <div class="mb-12">
            <!-- <StepEquipments
              v-bind:events="events"
              ref="StepEquipments"
              v-bind:eventInfo="evento"
            ></StepEquipments> -->

            <FrmSelectResources
              v-bind:events="events"
              ref="StepSelectEquipments"
              resources-type="Attrezzatura"
              v-bind:eventInfo="evento"
            ></FrmSelectResources>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="GetRealPageIndexFromPageId(6)">
          <div class="mb-12">
            <FrmSelectResources
              ref="StepSelectVehicles"
              v-bind:events="events"
              resources-type="Mezzo"
              v-bind:eventInfo="evento"
            ></FrmSelectResources>
            <!-- <StepVehicles
              v-bind:events="events"
              ref="StepVehicles"
              v-bind:eventInfo="evento"
            ></StepVehicles> -->
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn text @click="pageIndex--" v-if="pageIndex > 1"> Indietro </v-btn>
      <v-spacer></v-spacer>

      <v-btn
        v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        @click="CanGoFarward"
        v-if="pageIndex < tabs.length"
        :disabled="isLoadingEvents"
      >
        Avanti
      </v-btn>
      <v-btn
        v-bind:color="evento.idIntervento > 0 ? 'success' : 'primary'"
        @click="cmdSkip_Click"
        v-if="pageIndex < tabs.length"
        :disabled="isLoadingEvents"
      >
        Skip
      </v-btn>
      <v-btn
        color="success"
        depressed
        @click="submitEvent"
        v-if="
          pageIndex == tabs.length &&
          (evento.idIntervento == 0 || evento.idIntervento == undefined)
        "
      >
        Crea evento
      </v-btn>
      <v-btn
        color="success"
        depressed
        @click="updateEvent"
        v-if="pageIndex == tabs.length && evento.idIntervento > 0"
      >
        Modifica evento
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import StepCustomerHeadquarter from "./Steps/StepCustomerHeadquarter.vue";
import FrmSelectResources from "./FrmSelectResources";
import StepDataOra from "./Steps/StepDataOra.vue";
import EasyPlanClient from "../../utils/EasyPlanClient";
import StepFormOperatore from "./Steps/StepFormOperatore.vue";
import StepEquipments from "./Steps/StepEquipments.vue";
import StepVehicles from "./Steps/StepVehicles.vue";
import StepEventInfo from "./Steps/StepEventInfo.vue";
import UISettingsHelper from "../../utils/UISettingsHelper";
import moment from "moment";

export default {
  props: {
    evento: {
      type: Object,
      default: function () {
        return {
          commessa: {
            azienda: null,
            idAzienda: 26,
            idCommessa: 2685,
            codiceCommessa: "C012124",
            descrizione: "ccc",
            codiceCliente: null,
            interventi: null,
            isRemoved: false,
            data: "0001-01-01T00:00:00",
            riferimentoCommessaId: null,
            riferimentoPersona: null,
            email: null,
            telefono: null,
            indirizzoCantiere: null,
            cittaCantiere: null,
            capCantiere: null,
            provinciaCantiere: null,
          }, 
          descrizione: "this is a description",
          note: "",
          risorse: [],
          idCliente: 0,
          sedeId: 0,
          inizio: new Date(),
          fine: new Date(),
          giornoIntero: false,
          lampeggia: false, 

          indirizzoCantiere: "",
          cittaCantiere: "",
          capCantiere: "",
          provinciaCantiere: "",
          indirizzoCompleto:""
        };
      },
    },
  },

  data() {
    let data = {
      updateComponents:1,
      isLoadingEvents: false,
      pageIndex: 1,
      events: [],
      steps: [],
      tabs: [
        {
          id: 1,
          text: "Data e ora",
          index: 1,
          complete: () => this.pageIndex > 1,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
        {
          id: 2,
          text: "Operatori",
          index: 2,
          complete: () => this.pageIndex > 2,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
        {
          id: 3,
          text: "Dati Intervento",
          index: 3,
          complete: () => this.pageIndex > 3,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
        {
          id: 4,
          text: "Cliente",
          index: 4,
          complete: () => this.pageIndex > 4,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
        {
          id: 5,
          text: "Attrezzature",

          index: 5,
          complete: () => this.pageIndex > 5,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
        {
          id: 6,
          text: "Mezzi",
          index: 6,
          complete: () => this.pageIndex > 5,
          color: (ev) => (ev.idIntervento > 0 ? "success" : "primary"),
        },
      ],
      //   Descrizione: "this is a description",
      //   Risorse: [],
      //   idCliente: 0,
      //   sedeId: 0,
      //   Note: "",
      //   Inizio: new Date(),
      //   Fine: new Date(),
      //   GiornoIntero: false,
      // },
    };
    return data;
  },
  components: {
    StepCustomerHeadquarter,
    StepDataOra,
    StepFormOperatore,
    StepEquipments,
    StepVehicles,
    StepEventInfo,
    FrmSelectResources,
  },
  watch: {
    event: function (value, old) {
      if (old.idIntervento != value.idIntervento) this.pageIndex = 1;
      // console.debug("event changed");
      // console.debug(value);
      this.evento = value;
      // this.$forceUpdate();
    },
    evento(value, old) {
      if (value != null) {
        if (old.idIntervento != value.idIntervento) this.pageIndex = 1;
      } else {
        this.pageIndex = 1;
      }
      this.loadEvents(value.inizio);
    },
  },
  methods: {
    UpdateComponents(){
      this.updateComponents++;
    },
    GetStep(index) {
      return this.stepsRefs[index];
    },
    CanGoFarward() {
      let step = this.GetStep(this.GetRealPageIndex(this.pageIndex));
      if (step != null) {
        if (step.CanGoFarward != undefined) {
          if (step.CanGoFarward()) this.pageIndex = this.GetNextStep();
        } else this.pageIndex = this.GetNextStep();
      }
    },
    GetRealPageIndex(pageIndex) {
      var t = this.tabs.find((t) => t.index == pageIndex);
      if (t == undefined) return -1;
      else return t.id;
    },
    GetRealPageIndexFromPageId(pageId) {
      var t = this.tabs.find((t) => t.id == pageId);
      if (t == undefined) return -1;
      else return t.index;
    },
    GetNextStep() {
      let current = this.pageIndex;
      current++;
      while (this.GetRealPageIndex(current) < 0) current++;
      //  for(let next =current+1;this.GetRealPageIndex(next)<0;next++)
      //   current=next;

      return current;
    },
    commessa_selected(commessa){
      console.debug("Commessa cambiata",commessa);
      this.UpdateComponents();
    },
    checkData() {
      console.debug("check if it can go farward");
      if (!this.$refs.StepSelectOperators.CanGoFarward()) {
        console.debug("can't go farward");
        this.pageIndex = 2;
        return false;
      } else if (!this.$refs.StepEventInfo.CanGoFarward()) {
        console.debug("can't go farward");
        this.pageIndex = 3;
        return false;
      } else if (!this.$refs.StepCustomerHeadquarter.CanGoFarward()) {
        console.debug("can't go farward");
        this.pageIndex = 4;
        return false;
      } else if (!this.$refs.StepSelectEquipments.CanGoFarward()) {
        console.debug("can't go farward");
        this.pageIndex = 5;
        return false;
      } else if (!this.$refs.StepSelectVehicles.CanGoFarward()) {
        console.debug("can't go farward");
        this.pageIndex = 6;
        return false;
      } else {
        this.pageIndex = this.tabs.length;
        return true;
      }
    },
    cmdSkip_Click() {
      if (!this.isLoadingEvents) this.checkData();
    },
    loadEvents(inizio) {
      this.pageIndex = 1;
      this.isLoadingEvents = true;
      console.log("loading workers...");
      EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
        this.$route.params.companyAlias,
        inizio,
        inizio
      )
        .then((res) => {
          this.events = res.data.data;
          console.log(this.events);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.isLoadingEvents = false;
        });
    },

    ReloadSelectedVehiclesFromSteps() {
      console.debug("carico operatori");
      let selectedItems = this.$refs.StepSelectVehicles.GetSelectedResources();
      this.evento.risorse = this.evento.risorse.filter(
        (r) => r.tipo != "Mezzo"
      );
      this.evento.risorse.push(...selectedItems);
    },
    ReloadSelectedEquipmentsFromSteps() {
      console.debug("carico operatori");
      let selectedItems =
        this.$refs.StepSelectEquipments.GetSelectedResources();
      this.evento.risorse = this.evento.risorse.filter(
        (r) => r.tipo != "Attrezzatura"
      );
      this.evento.risorse.push(...selectedItems);
    },
    ReloadSelectedOperatorsFromSteps() {
      console.debug("carico operatori");
      let selectedOperators =
        this.$refs.StepSelectOperators.GetSelectedResources();
      this.evento.risorse = this.evento.risorse.filter((r) => r.tipo != "Uomo");
      this.evento.risorse.push(...selectedOperators);
    },
    ReloadEventDataFromSteps() {
      console.debug("carico dati evento da steps");
      this.ReloadSelectedOperatorsFromSteps();
      this.ReloadSelectedEquipmentsFromSteps();
      this.ReloadSelectedVehiclesFromSteps();
    },
    submitEvent: function () {
      if (this.checkData()) {
        this.ReloadSelectedOperatorsFromSteps();
        this.ReloadSelectedEquipmentsFromSteps();
        this.ReloadSelectedVehiclesFromSteps();
        console.debug("evento.risorse", this.evento.risorse);
        this.evento.risorseIntervento = [];
        // this.evento.inizio=moment(this.evento.inizio ).format("MM/DD/YYYY HH:mm");
        // this.evento.fine=moment(this.evento.fine ).format("MM/DD/YYYY HH:mm");
        for (var i = 0; i < this.evento.risorse.length; i++)
          this.evento.risorseIntervento.push({
            idRisorsa: this.evento.risorse[i].idRisorsa,
          });

        console.debug(
          "evento.risorseIntervento",
          this.evento.risorseIntervento
        );
        let tmp = { ...this.evento };
        this.evento.cliente = null;
        this.$emit("eventAdding", tmp);
        EasyPlanClient.Event.Insert(
          this.$route.params.companyAlias,
          this.evento
        )
          .then((res) => {
            console.debug("risposta add event:");
            console.debug(res);
            this.evento.risorse = [];
            this.$emit("eventAdded", res.data.data);
            // this.users.push(res.data.data);
            // this.loadUsers();
          })
          .catch((error) => {
            console.log(error);
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          });
      }
    },
    updateEvent: function () {
      if (this.checkData()) {
        this.ReloadSelectedOperatorsFromSteps();
        console.debug("Aggiorno intervento");
        // this.evento.inizio=this.evento.inizio.toLocaleString();
        // this.evento.fine=this.evento.fine.toLocaleString();
        this.evento.risorseIntervento = [];
        for (var i = 0; i < this.evento.risorse.length; i++)
          this.evento.risorseIntervento.push({
            idRisorsa: this.evento.risorse[i].idRisorsa,
          });
        EasyPlanClient.Event.Update(
          this.$route.params.companyAlias,
          this.evento.idIntervento,
          this.evento
        )
          .then((res) => {
            console.debug("risposta update event:");
            console.debug(res);
            this.evento.risorse = [];
            this.$emit("eventUpdated", res.data.data);
            // this.users.push(res.data.data);
            // this.loadUsers();
          })
          .catch((error) => {
            console.log(error);
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          });
      }
    },
  },
  computed: {
    UISettings() {
      UISettingsHelper.LoadSettings();
      return UISettingsHelper.GetSettings();
    },
    stepsRefs() {
      let steps = [];
      steps[1] = this.$refs.StepDataOra;
      steps[2] = this.$refs.StepSelectOperators;
      steps[3] = this.$refs.StepEventInfo;
      steps[4] = this.$refs.StepCustomerHeadquarter;
      steps[5] = this.$refs.StepSelectEquipments;
      steps[6] = this.$refs.StepSelectVehicles;
      return steps;
    },
  },
  mounted() {
    console.info("EVENTO", this.evento);
    // this.evento = this.event;
  },
  async created() {
    UISettingsHelper.Configure(this.$route.params.companyAlias);
    if (this.evento.commessa == undefined)
      this.evento.commessa = { descrizione: "" };
    this.loadEvents(this.evento.inizio);
    this.tabs = this.tabs.filter((t) =>
      this.UISettings.planner.tabsToShow.find((tts) => tts == t.id)
    );
    for (let i = 1; i <= this.tabs.length; i++) {
      this.tabs[i - 1].index = i;
    }
  },
};
</script>